import React from 'react';
import { Link } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import { PolicyPage } from '../styles/policyStyles';
import { useLanguage } from '../context/LanguageContext';

function SupportPage() {
  const { language } = useLanguage();
  const zh = language === 'zh';

  return (
    <>
      <SiteHeader />
      <PolicyPage>
        <h1>{zh ? '用户支持' : 'Support'}</h1>
        <p className="lede">
          {zh
            ? 'omw（在路上了）由独立开发者维护。每一封邮件都会直接送达。'
            : 'omw is built and maintained by one independent developer. Every email goes straight to me.'}
        </p>

        <h2>{zh ? '联系我们' : 'Contact us'}</h2>
        <p>
          {zh ? '邮箱：' : 'Email '}
          <a href="mailto:support@onmyway.city">support@onmyway.city</a>
          {zh ? '。我们将在两个工作日内回复。' : '. We aim to respond within two business days.'}
        </p>

        <h2>{zh ? '报告 Bug 或安全问题' : 'Report a bug or safety issue'}</h2>
        <p>
          {zh ? '如发现 Bug、用户不当行为或违反' : 'If you find a bug, encounter inappropriate behaviour, or see content that violates our '}
          <Link to="/terms">{zh ? '服务条款' : 'Terms'}</Link>
          {zh ? '的内容，请发邮件至 ' : ', email '}
          <a href="mailto:support@onmyway.city">support@onmyway.city</a>
          {zh ? '，并附上截图、对方昵称与时间。' : '. Please include screenshots, the user\'s display name, and when it happened.'}
        </p>
        <p>
          {zh
            ? '若涉及人身危险，请先拨打当地急救/报警电话。'
            : 'For urgent safety matters that involve danger to a person, contact your local emergency services first.'}
        </p>

        <h2>{zh ? '应用内拉黑或举报' : 'Block or report a user from inside the app'}</h2>
        <ul>
          <li>{zh ? '打开对方个人资料页。' : 'Open the user\'s profile.'}</li>
          <li>{zh ? '点击右上角菜单。' : 'Tap the menu button in the top-right corner.'}</li>
          <li>
            {zh
              ? '选择「拉黑」或「举报」。被拉黑用户无法查看你的资料、发消息或加入你主持的多人剧本。'
              : 'Choose "Block" or "Report". Blocked users cannot see your profile, send you messages, or join script-games you host.'}
          </li>
        </ul>

        <h2>{zh ? '删除账户' : 'Delete your account'}</h2>
        <p>{zh ? '你可随时删除账户及关联个人数据：' : 'You can delete your account and associated personal data at any time:'}</p>
        <ul>
          <li>
            <strong>{zh ? '应用内：' : 'In the app:'}</strong>{' '}
            {zh ? '个人资料 → 设置 → 账户 → 删除账户（输入 DELETE 确认）。' : 'Profile → Settings → Account → Delete account (type DELETE to confirm).'}
          </li>
          <li>
            <strong>{zh ? '邮件：' : 'By email:'}</strong>{' '}
            {zh ? '使用注册邮箱发信至 ' : 'send a request from the email tied to your account to '}
            <a href="mailto:privacy@onmyway.city">privacy@onmyway.city</a>
            {zh ? '，我们将在 30 天内处理。' : '. We process deletion within 30 days.'}
          </li>
        </ul>
        <p>
          {zh
            ? '删除后个人资料与联系方式将匿名化；法律要求保留的记录（如内购日志）会在法定最短期限内删除。'
            : 'Deletion anonymizes your profile and contact identifiers. Records we must keep by law (e.g. IAP logs) are retained for the minimum legal period, then deleted.'}
        </p>

        <h2>FAQ</h2>
        <h3>{zh ? '为什么地图上的内容有距离限制？' : 'Why is map content limited by distance?'}</h3>
        <p>
          {zh
            ? '宝藏等内容通常只在当前城市地理围栏内显示，鼓励步行或短途出行，避免远程「刷图」。'
            : 'Treasures and similar content appear inside the geofence for your current city. This keeps the game playable on foot or short transit and avoids remote farming.'}
        </p>
        <h3>{zh ? '为什么应用会使用我的位置？' : 'Why does the app use my location?'}</h3>
        <p>
          {zh ? '详见' : 'See our '}
          <Link to="/privacy">{zh ? '隐私政策' : 'Privacy Policy'}</Link>
          {zh
            ? '。简要说明：地图、活动、导航、轨迹录制、Cheese 近距离提醒（Premium）等功能需要位置；后台位置主要在导航或录制进行中使用。'
            : '. In short: maps, events, navigation, track recording, and Cheese proximity alerts (Premium) need location; background location is mainly used during active navigation or recording.'}
        </p>
        <h3>{zh ? '可以不使用真实姓名吗？' : 'Can I play without sharing my real name?'}</h3>
        <p>
          {zh
            ? '可以。昵称可自由设置；邮箱、手机号与登录标识不会对其他用户展示。'
            : 'Yes. Set whatever display name you like. Your email, phone, and login identifiers are never shown to other users.'}
        </p>
        <h3>{zh ? 'App Store 审核用哪些链接？' : 'Which URLs should I use for App Store Connect?'}</h3>
        <ul>
          <li>{zh ? '隐私政策：' : 'Privacy Policy URL: '}<a href="https://onmyway.city/privacy">https://onmyway.city/privacy</a></li>
          <li>{zh ? '支持 URL：' : 'Support URL: '}<a href="https://onmyway.city/support">https://onmyway.city/support</a></li>
          <li>{zh ? '服务条款：' : 'Terms URL: '}<a href="https://onmyway.city/terms">https://onmyway.city/terms</a></li>
        </ul>
      </PolicyPage>
      <SiteFooter />
    </>
  );
}

export default SupportPage;
